import { Module } from "vuex";

import Lang from "@/lang";
import { RootState } from "@/store";

export interface ConfirmDialogState {
  show: boolean;
  title: string;
  message: string;
  cancelText: string;
  confirmText: string;
  resolve?: (result: boolean) => void;
}

const state: ConfirmDialogState = {
  show: false,
  title: "",
  message: "",
  cancelText: Lang.cancel,
  confirmText: Lang.yes,
  resolve: undefined,
};

const confirmDialog: Module<ConfirmDialogState, RootState> = {
  namespaced: true,
  state,
  mutations: {
    setDialog(state, payload: Partial<ConfirmDialogState> & { resolve: (result: boolean) => void }) {
      Object.assign(state, payload, { show: true });
    },
    closeDialog(state: ConfirmDialogState) {
      state.show = false;
      state.resolve = undefined;
    },
  },
  actions: {
    open({ commit }, payload: Partial<Omit<ConfirmDialogState, "show" | "resolve">>) {
      return new Promise<boolean>((resolve) => {
        commit("setDialog", { ...payload, resolve });
      });
    },
    close({ commit }) {
      commit("closeDialog");
    },
  },
  getters: {
    isVisible: (state): boolean => state.show,
    dialogTitle: (state): string => state.title,
    dialogMessage: (state): string => state.message,
    dialogCancelText: (state): string => state.cancelText,
    dialogConfirmText: (state): string => state.confirmText,
    resolveFn: (state): ((result: boolean) => void) | undefined => state.resolve,
  },
};

export default confirmDialog;
